var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppSubTitle',{staticClass:"pl-4 mb-2",attrs:{"label":_vm.label}}),(_vm.value)?_c('div',{staticClass:"pl-4 mb-4"},[_vm._v(_vm._s(_vm.value))]):_c('div',{staticClass:"pl-4 mb-4"},[_vm._v("未設定")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }